/** @format */

export const externalfuncs = {
	nativeCallback: function (param) {
		Native('dataCallback', param);
	},
};
